import {__, includes} from "ramda";

export const shopCategoriesIdsWithReservationFeature = [
	8, // restaurants
];

const isEligibleForReservations = includes(__, shopCategoriesIdsWithReservationFeature);
export default isEligibleForReservations;
